module.exports = __webpack_public_path__ + "components/flag/static/square/tj-9157006d7b6b6de1d3ef98a732d710cd.svg";